import {createSvgIcon} from '../create-svg-icon';

export const WestIcon = createSvgIcon(
  <path d="m9 19 1.41-1.41L5.83 13H22v-2H5.83l4.59-4.59L9 5l-7 7 7 7z" />
, 'WestOutlined');
